var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slider',{staticClass:"images-slider",attrs:{"options":_vm.options}},_vm._l((_vm.images),function(img,i){return _c('slideritem',{key:i,staticClass:"images-slider__slide"},[_c('img',{attrs:{"src":img,"alt":"Faume"}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }